module.exports = "../../static/fonts/Gotham-Thin.38253ac.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Gotham-Thin.ttf
// module id = gyYr
// module chunks = 47